//EventoCadastroPage.jsx

import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "../../../axiosConfig";
import "./EventoCadastroPage.css";
import logoTikpag from "../../../assets/logo2.png";
import { useTypewriter } from "../../../hooks/useTypewriter"; // ajuste o caminho
import { motion, AnimatePresence } from "framer-motion";

import { validarSenhaFrontend } from "../../../utils/senhaUtils";



const EventoCadastroPage = () => {
  const { slug } = useParams();

  const [etapa, setEtapa] = useState(1);
  const [mensagem, setMensagem] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [empresa, setEmpresa] = useState(null);
  const [cpf, setCpf] = useState("");
  const [usuario, setUsuario] = useState(null);
  const [nome, setNome] = useState("");
  const [telefone, setTelefone] = useState("");
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [erro, setErro] = useState("");
  const textoDigitado = useTypewriter(mensagem, 30);
  const [mostrarRecuperarSenha, setMostrarRecuperarSenha] = useState(false);
  const [carregandoInicial, setCarregandoInicial] = useState(true);
  const [loading, setLoading] = useState(false);




function validarCPF(cpf) {
  cpf = cpf.replace(/[^\d]+/g, '');
  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;
  let soma = 0;
  for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i);
  let resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.charAt(9))) return false;
  soma = 0;
  for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  return resto === parseInt(cpf.charAt(10));
}


useEffect(() => {
  let texto = "";
  switch (etapa) {
    case 1:
      texto = "Vamos ao sorteio do seu prêmio! Informe o CNPJ da empresa.";
      break;
    case 2:
      texto = empresa?.razao_social
        ? `Empresa localizada: ${empresa.razao_social}. Agora digite seu CPF.`
        : "Ótimo! Agora digite seu CPF.";
      break;
    case 3:
      texto = "Agora informe seu Nome e um Sobrenome.";
      break;
    case 4:
      texto = "Excelente! Informe seu telefone para podermos falar com você.";
      break;
    case 5:
      texto = "Pronto! Agora informe seu e-mail e crie uma senha para acessar seu prêmio.";
      break;
    case 6:
      texto =
        "Bem-vindo de volta! Informe seu e-mail e sua senha Tikpontos para continuar.";
      break;
    default:
      texto = "";
  }

  if (mensagem !== texto) setMensagem(texto); // ⬅️ Evita redefinir desnecessariamente
}, [etapa, empresa?.razao_social, nome]);


useEffect(() => {
  if (etapa === 6) setSenha("");
}, [etapa]);

const avancar = async () => {
  setErro("");
  setLoading(true);

  try {
    if (etapa === 1) {
  const apenasNumeros = cnpj.replace(/\D/g, "");
  if (apenasNumeros.length !== 14) {
    setErro("Digite um CNPJ válido com 14 dígitos.");
    return;
  }

  try {
    const res = await axios.post("/api/eventos/verificar-cnpj", { cnpj });
    setEmpresa(res.data);
    setEtapa(2);
  } catch (err) {
    if (err.response?.status === 404) {
      setErro("CNPJ não encontrado. Sua empresa não está habilitada neste evento. Fale com a Tikpag.");
    } else {
      setErro("Erro ao consultar a empresa.");
    }
  }


  } else if (etapa === 2) {
    const apenasNumeros = cpf.replace(/\D/g, "");

    if (!validarCPF(apenasNumeros)) {
      setErro("Digite um CPF válido.");
      return;
    }

    const res = await axios.post(
      "/api/eventos/verificar-cpf",
      { cpf }
    );

    if (res.data?.cadastrado) {
      // CPF já possui cadastro.
      // Login será necessário para obter os dados do usuário.
      setEtapa(6);
    } else {
      // Novo participante
      setEtapa(3);
    }


      } else if (etapa === 5) {
        if (!senha || senha !== confirmarSenha) {
          return setErro("As senhas não coincidem.");
        }

        const validacaoSenha = validarSenhaFrontend(senha);

        if (!validacaoSenha.valida) {
          setErro(validacaoSenha.mensagem);
          return;
        }

        const res = await axios.post("/api/eventos/registrar", {
          nome,
          email,
          telefone,
          senha,
          cpf_cnpj: cpf,
          cidade: empresa.cidade,
          estado: empresa.estado,
          cnpj_empresa: cnpj,
          tipo_pessoa: "fisica",
          tipo: "cliente",
        });

      if (res.data?.cliente_id) {
          const loginRes = await axios.post("/api/eventos/login", { email, senha });
          const token = loginRes.data?.token;

          if (token) {
            axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
            localStorage.setItem("token", token);
            localStorage.setItem("usuario", JSON.stringify(loginRes.data.usuario));
            localStorage.setItem("origem_login", "evento");
            localStorage.setItem("evento_slug", slug);

            // 🟡 Realiza sorteio antecipado
            try {
              const sorteioRes = await axios.post(
                  `/api/eventos/sorteio/${slug}`
                );
              const resultado = sorteioRes.data?.premio;
              localStorage.setItem("sorteio_resultado", JSON.stringify(resultado));
              localStorage.setItem("participou_evento", "sim");
            } catch (err) {
              console.error("❌ Erro ao sortear após cadastro:", err);
              localStorage.setItem("sorteio_resultado", null);
              localStorage.setItem("participou_evento", "erro");
            }

            window.location.href = "/painel-cliente";
          }
        }


        } else if (etapa === 6) {
      try {
        const res = await axios.post("/api/eventos/login", { email, senha });
        const token = res.data?.token;

        if (token) {
          localStorage.setItem("token", token);
          localStorage.setItem("usuario", JSON.stringify(res.data.usuario));
          axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          localStorage.setItem("origem_login", "evento");
          localStorage.setItem("evento_slug", slug);

         // 🟡 Realiza sorteio imediatamente após login
        try {
          const sorteioRes = await axios.post(
              `/api/eventos/sorteio/${slug}`
            );
          const resultado = sorteioRes.data?.premio;
          localStorage.setItem("sorteio_resultado", JSON.stringify(resultado));
          localStorage.setItem("participou_evento", "sim");
        } catch (err) {
          console.error("❌ Erro ao sortear após login:", err);
          localStorage.setItem("sorteio_resultado", null);
          localStorage.setItem("participou_evento", "erro");
        }

        window.location.href = "/painel-cliente";

        }
      } catch (err) {
        if (err.response?.status === 401) {
          setErro("E-mail ou senha inválidos. Tente novamente.");
        } else if (err.response?.status === 404) {
          setErro("Usuário não encontrado.");
        } else {
          setErro("Erro ao tentar fazer login. Tente novamente.");
        }
      }


    } else {
      setEtapa(etapa + 1);
    }

  } catch {
    setErro("Ocorreu um erro ao processar sua solicitação.");
   } finally {
    setLoading(false); // ← Garantido para qualquer caminho
  }
};


useEffect(() => {
  const timeout = setTimeout(() => {
    setCarregandoInicial(false);
  }, 800); // ou aumente para 1000 se quiser mais perceptível

  return () => clearTimeout(timeout);
}, []);



const voltar = () => {
  if (etapa === 6) {
    setSenha(""); // limpa senha do login
    setEtapa(2);  // volta para CPF
  } else if (etapa === 5) {
    setSenha("");
    setConfirmarSenha("");
    setEtapa(4);
  } else if (etapa === 4) {
    setTelefone("");
    setEtapa(3);
  } else if (etapa === 3) {
    setNome("");
    setEtapa(2);
  } else if (etapa === 2) {
    setCpf("");
    setEtapa(1);
  }
};


  const renderEtapa = () => {
    switch (etapa) {
      case 1:
        return (
          <div className="etapa-slide">
            <input
              type="text"
              id="cnpj"
              name="cnpj"
              autoComplete="off"
              value={cnpj}
              onChange={(e) => setCnpj(e.target.value)}
              placeholder="CNPJ da empresa"
            />
            <button onClick={avancar}>Continuar</button>
          </div>
        );
      case 2:
        return (
          <div className="etapa-slide">
            <p className="empresa-detectada">
              Empresa detectada: <strong>{empresa?.razao_social || "..."}</strong>
            </p>
            <input
              type="text"
              id="cpf"
              name="cpf"
              autoComplete="off"
              value={cpf}
              onChange={(e) => setCpf(e.target.value)}
              placeholder="CPF"
            />
            <button onClick={avancar}>Continuar</button>
          </div>
        );
      case 3:
        return (
          <div className="etapa-slide">
            <input
              type="text"
              id="nome"
              name="nome"
              autoComplete="name"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              placeholder="Nome completo"
            />
            <button onClick={() => setEtapa(4)}>Continuar</button>
          </div>
        );
      case 4:
        return (
          <div className="etapa-slide">
            <input
              type="tel"
              id="telefone"
              name="telefone"
              autoComplete="tel"
              value={telefone}
              onChange={(e) => setTelefone(e.target.value)}
              placeholder="Telefone"
            />
            <button onClick={() => setEtapa(5)}>Continuar</button>
          </div>
        );
      case 5:
        return (
          <div className="etapa-slide">
            <input
              type="email"
              id="email"
              name="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="E-mail"
            />
            <input
              type="password"
              id="senha"
              name="senha"
              autoComplete="new-password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              placeholder="Senha"
            />
            <input
              type="password"
              id="confirmarSenha"
              name="confirmarSenha"
              autoComplete="new-password"
              value={confirmarSenha}
              onChange={(e) => setConfirmarSenha(e.target.value)}
              placeholder="Confirmar senha"
            />
            <button onClick={avancar} disabled={loading}>
  {loading ? "Aguarde..." : "Finalizar"}
</button>

          </div>
        );
    case 6:
      return (
        <div className="etapa-slide">
          <input
            type="email"
            id="emailLogin"
            name="emailLogin"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="E-mail cadastrado"
          />

          <input
            type="password"
            id="senhaLogin"
            name="senhaLogin"
            autoComplete="current-password"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            placeholder="Senha"
          />

          <button onClick={avancar} disabled={loading}>
            {loading ? "Aguarde..." : "Entrar"}
          </button>



      {/* Botão para exibir mensagem de recuperação */}
      <button
        type="button"
        className="btn-link esqueceu-senha"
        onClick={() => setMostrarRecuperarSenha(true)}
      >
        Esqueci minha senha
      </button>

      {/* Mensagem e link condicional */}
      {mostrarRecuperarSenha && (
        <div className="recuperar-senha-box">
          <p className="recuperar-senha-msg">
            Para redefinir sua senha clique no link abaixo. <br />
            Quando recuperar sua senha, acesse o QR Code novamente para reiniciar o processo!
          </p>
          <a
            href="https://www.tikpontos.com.br/esqueci-senha"
            className="recuperar-senha-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Redefinir minha senha
          </a>
        </div>
      )}
    </div>
  );

      default:
        return null;
    }
  };


if (carregandoInicial) {
  return (
    <AnimatePresence>
      <motion.div
        className="evento-preloader"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="preloader-spinner" />
        <p className="preloader-texto">Carregando evento...</p>
      </motion.div>
    </AnimatePresence>
  );
}


  return (
    <div className="evento-cadastro-wrapper">
      <div className="form-container animate-slide">
        <img src={logoTikpag} alt="Tikpag" className="logo-tikpag" />
  <p className="evento-slug-visivel">Evento: <strong>{slug?.toUpperCase()}</strong></p>  
<p className="mensagem-animada">
  {textoDigitado}
</p>


        <div className="form-etapa">{renderEtapa()}</div>
        {erro && <p className="mensagem-erro">{erro}</p>}
        
          {etapa > 1 && etapa < 6 && (
  <button className="btn-voltar" onClick={voltar} disabled={loading}>
    ← Voltar
  </button>
)}
        
      </div>
    </div>
  );
};

export default EventoCadastroPage;
